module.exports = __webpack_public_path__ + "img/statistics_outline_64.47d547bd.svg";